import { useStore } from 'effector-react'
import * as React from 'react'
import { $kpiByMonth, getKpiByMonth, kpiMounted } from './model'

export const useKpiByMonth = () => {
  React.useEffect(() => {
    kpiMounted()
  }, [])

  const kpiByMonth = useStore($kpiByMonth)
  const loading = useStore(getKpiByMonth.pending)

  return { kpiByMonth, loading }
}
